export function waitForAnimation(element, timeoutMs = 600) {
    return new Promise((resolve) => {
        let done = false;
        const finish = () => {
            if (done) {
                return;
            }
            done = true;
            element.removeEventListener('animationend', onEnd);
            clearTimeout(timer);
            resolve();
        };
        const onEnd = (event) => {
            // Ignore bubbled animationend from children (stagger rows, etc.)
            if (event.target !== element) {
                return;
            }
            finish();
        };
        const timer = setTimeout(finish, timeoutMs);
        element.addEventListener('animationend', onEnd);
    });
}

export async function fadeOut(element) {
    if (!element || element.classList.contains('is-hidden')) {
        return;
    }
    element.classList.remove('view-enter', 'stagger-enter');
    element.classList.add('view-exit');
    await waitForAnimation(element);
    element.classList.remove('view-exit');
    element.classList.add('is-hidden');
}

export async function fadeIn(element) {
    if (!element) {
        return;
    }
    element.classList.remove('is-hidden', 'view-exit');
    element.classList.add('view-enter');
    await waitForAnimation(element);
    element.classList.remove('view-enter');
}

export async function crossFade(hideElement, showElement) {
    await fadeOut(hideElement);
    await fadeIn(showElement);
}

export function showLoadingOverlay(message) {
    const overlay = document.getElementById('loading-overlay');
    document.getElementById('loading-overlay-message').textContent = message;
    overlay.classList.remove('is-hidden', 'overlay-exit');
    overlay.classList.add('overlay-enter');
}

export async function hideLoadingOverlay() {
    const overlay = document.getElementById('loading-overlay');
    overlay.classList.remove('overlay-enter');
    overlay.classList.add('overlay-exit');
    await waitForAnimation(overlay);
    overlay.classList.add('is-hidden');
    overlay.classList.remove('overlay-exit');
}

export function staggerChildren(parent, childSelector, baseDelayMs = 80, startDelayMs = 0) {
    const children = parent.querySelectorAll(childSelector);
    children.forEach((child, index) => {
        child.classList.remove('stagger-enter');
        child.style.animationDelay = '';
        child.classList.add('stagger-enter');
        child.style.animationDelay = `${startDelayMs + index * baseDelayMs}ms`;
    });
}

export function animateElement(element, delayMs = 0) {
    if (!element) {
        return;
    }
    element.classList.remove('stagger-enter', 'view-enter');
    element.style.animationDelay = '';
    element.classList.add('stagger-enter');
    element.style.animationDelay = `${delayMs}ms`;
}
